import { Tag } from 'antd'
import styles from './Tag.module.less'
import { DataTestId } from 'src/constants/ui.constants'

export type TagCompProps = {
    bordered?: boolean
    closable?: boolean
    isUppercase?: boolean
    label: string
    onClose?: () => void
    style?: React.CSSProperties
    color?: 'gold' | 'green' | 'cloud' | 'white' | 'gray' | 'steel'
    isRounded?: boolean
    textWeight?: 'normal' | 'medium'
    textAlign?: 'left' | 'center' | 'right'
    textWrap?: 'wrap' | 'nowrap'
    textEllipsis?: boolean
    fitWidth?: boolean
    fullWidth?: boolean
}

const TagComp: React.FC<TagCompProps> = props => {
    const handleClose = (e: React.MouseEvent) => {
        e.preventDefault()
        if (props.onClose) {
            props.onClose()
        }
    }

    const classes = [
        styles.tag,
        props.color && styles[props.color],
        props.isRounded && styles.rounded,
        props.textWeight && styles[props.textWeight],
        props.textAlign && styles[props.textAlign],
        props.textWrap && styles[props.textWrap],
        props.textEllipsis && styles.ellipsis,
        props.fullWidth && styles.fullWidth,
        props.fitWidth && styles.fitWidth,
    ]
        .filter(Boolean)
        .join(' ')

    return (
        <Tag
            bordered={props.bordered ?? false}
            className={classes}
            closable={props.closable ?? false}
            onClose={handleClose}
            style={props.style}
            data-testid={DataTestId.Tag}
        >
            <div className={props.textEllipsis ? styles.ellipsis : undefined}>
                {props.isUppercase ? props.label.toUpperCase() : props.label}
            </div>
        </Tag>
    )
}

export default TagComp
